import * as Yup from 'yup';
import { IBatchesData, ISettlementsTableRowData } from '../../interfaces/funds';

  export enum COMMENT_FORM_FIELD {
    COMMENT = 'comment',
  INTERNAL_COMMENT = 'internalComment'
}

export enum COMMENT_FORM_FIELD_NAME {
  COMMENT = 'PENDING_PAYOUTS.COMMENT',
  PUBLIC_COMMENT = 'PENDING_PAYOUTS.PUBLIC_COMMENT_MODAL_TITLE',
  INTERNAL_COMMENT = 'PENDING_PAYOUTS.INTERNAL_COMMENT_MODAL_TITLE',
  COMMENT_PLACEHOLDER = 'PENDING_PAYOUTS.COMMENT_PLACEHOLDER'
}

export const commentInitialValues = {
  [COMMENT_FORM_FIELD.COMMENT]: '',
  [COMMENT_FORM_FIELD.INTERNAL_COMMENT]: ''
};

export const commentDetailsSchema = Yup.object().shape({
  [COMMENT_FORM_FIELD.COMMENT]: Yup.string()
    .max(500, 'Max 500 characters')
    .required('Comment required'),
});

export const internalCommentValidationSchema = Yup.object().shape({
  [COMMENT_FORM_FIELD.INTERNAL_COMMENT]: Yup.string()
    .max(500, 'Max 500 characters')
    .required('Comment required')
});

export const convertToInitialCommentValues = (data: IBatchesData | ISettlementsTableRowData): any => ({
  [COMMENT_FORM_FIELD.COMMENT]: data?.comment ?? '',
  [COMMENT_FORM_FIELD.INTERNAL_COMMENT]: data?.internalComment ?? ''
});


